export const TICKETING_SYSTEM_PATH = '/Ticketing System';
